<template lang="pug">
div(v-if="!loading")

  div(v-if="feedback")

    div(style="display: flex; flex-direction: column; align-items: center; margin-top: 32px")

      h1(style="margin: 0") {{ feedback.orderScore }}

      el-rate(:value="feedback.orderScore" disabled)

      p(v-if="feedback.orderFeedback" style="color: #999; font-size: 16px;")
        | “
        | {{ feedback.orderFeedback }}
        | ”

      p(style="color: #999; font-size: 12px;")
        | Avaliada em:
        | {{ dateTimeToLocaleDateTime(feedback.createdAt) }}

    h5(style="margin-bottom: 0") Avaliações dos produtos

    el-table(
      :data="productFeedbacks"
      style="width: 100%"
      size="mini"
    )
      el-table-column(
        prop="productId"
        label="#"
        width="60"
      )
      el-table-column(
        prop="product.brand.name"
        label="Marca"
        width="120"
      )
      el-table-column(
        prop="product.displayName"
        label="Produto"
        width="320"
        show-overflow-tooltip
      )
      el-table-column(
        prop="score"
        label="Avaliação"
        width="120"
        sortable
      )
      el-table-column(
        prop="feedback"
        label="Feedback"
        sortable
      )

  div(v-else)
    el-empty(description="Nenhuma avaliação encontrada")
</template>
<script setup>
import SubscriptionBoxOrderService from '@/services/fulfillment/SubscriptionBoxOrderService';
import { useMessage } from '@/utils/Message';
import { computed } from 'vue';
import { ref } from 'vue';
import { watch } from 'vue';
import { dateTimeToLocaleDateTime } from '@/utils/DateTimeUtils';

const props = defineProps({
  orderId: {
    type: Number,
    required: true
  },
  products: {
    type: Array,
    required: true
  }
})

const message = useMessage()

const loading = ref(true)
const feedback = ref(null)

const score = computed(() => `${feedback.value.orderScore} / 5`)

const productById = computed(() => {
  const p = {};
  props.products.forEach(product => {
    p[product.id] = product;
  })

  return p;
})

const productFeedbacks = computed(() => {
  const feedbacks = [];

  for (const productFeedback of feedback.value.productFeedbacks) {
    feedbacks.push({
      ...productFeedback,
      product: productById.value[productFeedback.productId]
    });
  }

  return feedbacks;
})

const reload = async() => {
  loading.value = true;

  try {
    feedback.value = await SubscriptionBoxOrderService.getFeedback(props.orderId);
  } catch(e) {
    if (e.status !== 404) {
      console.error(e)

      message.error("Erro ao carregar feedback")
    }
  } finally {
    loading.value = false;
  }
}

watch(() => props.id, reload, { immediate: true })
</script>
